<template>
  <div class="organizations-list">
    <v-banner color="error" dark v-if="fetchError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ fetchError }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all <strong>organizations</strong>. You can add, edit or delete organizations. </span>
        <span>Organizations are <strong>main logical separation between users</strong>. Users that are not in the organization cannot see concepts, locations, and users of other organizations, whatever their role is in their own organization.</span>
        <span>In each organization, you can grant to users the role of <strong>organization administrator</strong>, which is granting him rights to manage organization users, manage concepts and locations accesses and applications accesses.</span>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <OrganizationsTable
        v-on:refresh="fetchAll"
        v-on:createNew="openOrganizationCreationDialog"
        v-on:editOrga="goToDetailedOrganization"
        v-on:deleteOrga="openOrganizationDeletionDialog"
      />
      <OrganizationCreationDialog
        :dialog="creationDialog"
        v-on:cancel="creationDialog = false"
        v-on:save="createOrganization"
        ref="creationDialog"
      />
      <OrganizationDeletionDialog
        :dialog="deletionDialog"
        :organization="selectedOrganization"
        v-on:cancel="deletionDialog = false"
        v-on:deleteOrga="deleteOrganization"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import mixin from "@/mixins";
import OrganizationsTable from "@/components/Admin/Organizations/OrganizationsTable";
import OrganizationCreationDialog from "@/components/Admin/Organizations/OrganizationCreationDialog";
import OrganizationDeletionDialog from "@/components/Admin/Organizations/OrganizationDeletionDialog";

export default {
  mixins: [mixin],
  name: "OrganizationsList",
  components: {
    OrganizationsTable,
    OrganizationCreationDialog,
    OrganizationDeletionDialog
  },
  data() {
    return {
      creationDialog: false,
      deletionDialog: false,
      snackbar: false,
      errorMessage: "",
      selectedOrganization: {},
      displayInfo: false,
    };
  },
  computed: {
    ...mapState({
      fetchError: state => state.organizations.fetchAll.error
    })
  },
  methods: {
    ...mapActions("organizations", { fetchAll: "fetchAll" }),
    ...mapActions("organizations", { createOne: "createOne" }),
    ...mapActions("organizations", { deleteOne: "deleteOne" }),
    openOrganizationCreationDialog() {
      this.creationDialog = true;
    },
    openOrganizationDeletionDialog(organization) {
      this.selectedOrganization = organization;
      this.deletionDialog = true;
    },
    goToDetailedOrganization(organization) {
      this.$router.push(`/admin/organizations/${organization.uuid}`);
    },
    createOrganization(name) {
      this.createOne({ name: name })
        .then(() => {
          this.fetchAll();
          this.creationDialog = false;
          this.$refs.creationDialog.reset();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteOrganization(uuid) {
      this.deleteOne({ organizationUuid: uuid })
        .then(() => {
          this.fetchAll();
          this.deletionDialog = false;
          this.selectedOrganization = {};
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>